module.exports = require('./helpers/bundle-url').getBundleURL('b5dX6') + "annotation-result-failed-icon.551564eb.svg";